import { Component, OnInit, ViewChild, EventEmitter, Output } from '@angular/core';
// import { ZXingScannerComponent } from '@zxing/ngx-scanner';

@Component({
  selector: 'lc-scanner',
  templateUrl: './scanner.component.html',
  styleUrls: ['./scanner.component.scss']
})
export class ScannerComponent implements OnInit {

  device_selected: boolean;
  show_scanner: boolean;
  // @ViewChild('scanner') scanner: ZXingScannerComponent;
  @Output() scanResult: EventEmitter<string> = new EventEmitter();


  constructor() { }

  ngOnInit() {
  }

  toggleScanner(option?: string) {
    // if (!!option && option === 'close') {
    //   this.show_scanner = false;
    // } else {
    //   this.show_scanner = true;
    // }
  }

  camerasFoundHandler(event) {
      // this.device_selected = true;
  }

  scanCompleteHandler(event) {
    // if (!!event && !!event.text) {
    //   this.toggleScanner('close');
    //   this.scanResult.emit(event.text);
    // }
  }

}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/components/scanner/scanner.component.ts